import _ from "lodash";
import {
  Component,
} from "react";

import store from "CommonState/store";
import {
  Panel,
  Spinner,
} from "CommonComponents/bricks";

import {
  createSHKEditorWithPosition,
} from "App/mn-editors"; // TH: hier mn-editors (fork von mn-context)
import {
  schemaAlsHilfskraft,
  schemaAlsLehrauftrag,
  schemaAlsTarifangestellter,
  schemaAusserhalb,
  schemaBefristet12Monate,
  schemaHilfskraft,
  schemaLehrauftrag,
} from "Apis/person-weiterebv-api";

import {
  createInjectsSelector,
  injectsFromSchemaAndRenderMethods,
} from "CommonCore/schema-util";
import apifetch from "CommonCore/apifetch";
import SHKFormTab, {
  patchPrefix,
} from "App/shk-form-tab";
import {
  ANTRAGSTELLERMODUS,
  ASTMODUSKEY,
  getModusFromAntrag,
  WBTYPE,
} from "App/constants";

export const panels = [
  {
    key: "weiterebv",
    header: "Vorherige / weitere Beschäftigungsverhältnisse",
    schema: schemaAlsHilfskraft,
    endpoint: "/api/shkperson/person",
  },
];

// Info: Die Subpanels werden hier nur für Metadaten verwendet und nicht direkt an eine SHKFormTab übergeben
export const subpanels = [
  {
    key: "hilfskraft",
    header: "Beschäftigung als studentische / wissenschaftliche Hilfskraft",
    schema: schemaHilfskraft,
    endpoint: "/api/shkperson/weiterebv",
  },
  {
    key: "tarifangestellter",
    header: "Vorherige Beschäftigungen",
    schema: schemaHilfskraft, // Logik für Tarif ist in diesem Schema
    endpoint: "/api/shkperson/weiterebv",
  },
  {
    key: "lehrauftrag",
    header: "Zusätzliche Lehraufträge",
    schema: schemaLehrauftrag,
    endpoint: "/api/shkperson/weiterebv",
  },
  {
    key: "ausserhalb",
    header: "Weitere parallel ausgeübte Beschäftigungsverhältnisse",
    schema: schemaAusserhalb,
    endpoint: "/api/shkperson/weiterebv",
  },
  {
    key: "ausserhalb_tarif",
    header: "Zusätzliche Beschäftigungen",
    schema: schemaAusserhalb, // hier kann ggf für Tarif ein anderes Schema genutzt werden
    endpoint: "/api/shkperson/weiterebv",
  },
  {
    key: "befristet_12Monate",
    header: "Befristete Beschäftigungsverhältnisse in den letzten 12 Monaten vor Vertragsbeginn",
    schema: schemaBefristet12Monate,
    endpoint: "/api/shkperson/weiterebv",
  },

];
_.map(subpanels, panel => _.assign(panel, { route: "/person/weiterebv", label: "Vorherige / weitere Beschäftigungsverhältnisse" }));

const injects = [
  ...injectsFromSchemaAndRenderMethods(schemaHilfskraft), ...injectsFromSchemaAndRenderMethods(schemaAusserhalb),
  "k_stundensatzLookup",
];

const selectInjects = createInjectsSelector(injects);


const Hilfskraft = createSHKEditorWithPosition([schemaHilfskraft], [], null, { property: "hilfskraft", id: "pwb_id", wbtype: WBTYPE.Hilfskraft });
const actionHilfskraft = {
  buttonUpName: "Hilfskraft-Tätigkeit bearbeiten",
  extraClass: "tatigkeit",
};

const Lehrauftrag = createSHKEditorWithPosition([schemaLehrauftrag], [], null, { property: "lehrauftrag", id: "pwb_id", wbtype: WBTYPE.Lehrauftrag });
const actionLehrauftrag = {
  buttonUpName: "Lehraufträge bearbeiten",
  extraClass: "tatigkeit",
};

const Ausserhalb = createSHKEditorWithPosition([schemaAusserhalb], [], null, { property: "ausserhalb", id: "pwb_id", wbtype: WBTYPE.Ausserhalb });
const actionAusserhalb = {
  buttonUpName: "Weitere Beschäftigung bearbeiten",
  extraClass: "tatigkeit",
};

const BefristetJahresbeginn = createSHKEditorWithPosition([schemaBefristet12Monate], [], null, { property: "befristet_12Monate", id: "pwb_id", wbtype: WBTYPE.Befristet_12Monate });
const actionBefristetJahresbeginn = {
  buttonUpName: "Weitere Beschäftigung seit Jahresbeginn bearbeiten",
  extraClass: "tatigkeit",
};


@store(...injects, "user", "flag_antragstellermodus")
export default class PersonBeschaeftigungTab extends Component {
  constructor() {
    super();
    this.state = {
      edits: {},
      needDetail: false,
      schemaHilfskraft: schemaHilfskraft,
      schemaLehrauftrag: schemaLehrauftrag,
      schemaAusserhalb: schemaAusserhalb,
      schemaBefristet12Monate,
      filteredPanels: null,
      hilfskraftPanel: null,
      lehrauftragPanel: null,
      ausserhalbPanel: null,
      panelHeaderSubjects: null,
    };
  }

  async refetch() {
    const { antrag } = this.props;
    if (!antrag) {
      const list = await apifetch(`/api/shkperson/weiterebv`);
      this.setState({ list: list.data });
    } else {
      const result = await apifetch(`/api/shkantrag/antrag/${ antrag.a_id }`);

      this.setState({ needDetail: true, list: result.data[0].antrag_weiterebv || [] });
    }
  }

  componentDidMount() {
    const { schemaHilfskraft, schemaAusserhalb, schemaBefristet12Monate } = this.state;
    this.refetch();
    // Wenn wir uns mit Antragsdaten befassen, müssen wir die Prefixe der Felder anpassen
    if (this.props.antrag) {
      patchPrefix(schemaHilfskraft.table, "pwb_", "awb_");
      patchPrefix(schemaAusserhalb.table, "pwb_", "awb_");
      patchPrefix(schemaAusserhalb.table, "pwb_", "awb_");
      patchPrefix(schemaBefristet12Monate.table, "pwb_", "awb_");
      this.setState({ schemaHilfskraft, schemaAusserhalb, schemaBefristet12Monate });
    } else {
      patchPrefix(schemaHilfskraft.table, "awb_", "pwb_");
      patchPrefix(schemaAusserhalb.table, "awb_", "pwb_");
      patchPrefix(schemaAusserhalb.table, "awb_", "pwb_");
      patchPrefix(schemaBefristet12Monate.table, "awb_", "pwb_");
      this.setState({ schemaHilfskraft, schemaAusserhalb, schemaBefristet12Monate });
    }
    this.initPanels();
  }

  componentDidUpdate = prevProps => {
    if (prevProps.flag_antragstellermodus !== this.props.flag_antragstellermodus ||
      !_.isEqual(prevProps.antrag, this.props.antrag)) {
      this.initPanels(this.props);
    }
  };

  initPanels(nextProps = this.props) {
    const { flag_antragstellermodus, antrag } = nextProps;
    const modus = ANTRAGSTELLERMODUS[flag_antragstellermodus || (antrag && getModusFromAntrag(antrag))];
    const lehrvertrag = modus?.value === ASTMODUSKEY.Lehrauftrag;
    const tarifvertrag = modus?.value === ASTMODUSKEY.Tarif;
    this.setState({
      hilfskraftPanel: lehrvertrag ? null : tarifvertrag ? subpanels[1] : subpanels[0],
      lehrauftragPanel: lehrvertrag ? subpanels[2] : null,
      ausserhalbPanel: lehrvertrag ? null : tarifvertrag ? subpanels[4] : subpanels[3],
      befristetPanel: lehrvertrag ? null : subpanels[5],
      filteredPanels:
        panels.map(x => {
          if (lehrvertrag && x.key === "weiterebv") {
            x.header = "Weitere Lehraufträge";
            x.schema = schemaAlsLehrauftrag;
          } else {
            x.header = "Vorherige / weitere Beschäftigungsverhältnisse";
            x.schema = tarifvertrag ? schemaAlsTarifangestellter : schemaAlsHilfskraft;
          }
          return x;
        }),
      panelHeaderSubjects: lehrvertrag
        ? ["Lehraufträge", "Lehrkraft", "Lehraufträge"]
        : ["Beschäftigungsverhältnisse", "Hilfskraft", "Beschäftigungen"],
      istTarifvertrag: tarifvertrag,
    });
  }

  get entityContainer() {
    // Pseudo-Objekt liefern, dass Datensätze zu jeder Geschmacksrichtung beinhaltet
    const { list } = this.state;
    const { antrag } = this.props;
    const entity = {
      hilfskraft: [],
      lehrauftrag: [],
      ausserhalb: [],
      befristet_12Monate: [],
    };
    _.map(list, item => {
      const feldName = antrag ? "awb_type" : "pwb_type";
      switch (item[feldName]) {
        case WBTYPE.Hilfskraft: {
          entity.hilfskraft.push(item);
          break;
        }
        case WBTYPE.Ausserhalb: {
          entity.ausserhalb.push(item);
          break;
        }
        case WBTYPE.Lehrauftrag: {
          entity.lehrauftrag.push(item);
          break;
        }
        case WBTYPE.Befristet_12Monate: {
          entity.befristet_12Monate.push(item);
          break;
        }
      }
    });
    return entity;
  }

  render = () => {
    const {
      list,
      needDetail,
      schemaHilfskraft,
      schemaLehrauftrag,
      schemaAusserhalb,
      hilfskraftPanel,
      lehrauftragPanel,
      ausserhalbPanel,
      befristetPanel,
      filteredPanels,
      panelHeaderSubjects,
      istTarifvertrag,
    } = this.state;

    const { antrag } = this.props;

    if (!list) {
      return <Spinner />;
    }

    const { entityContainer } = this;
    return <div>

      {!antrag && filteredPanels && <SHKFormTab
        subpanels={filteredPanels}
        injects={selectInjects(this.props)}
        onUpdate={this.onBVInfo}
      />}

      {needDetail && <Panel className='detail-form'>
        {!antrag && <span>
          <ul>Bitte hinterlegen Sie hier Informationen zu weiteren {panelHeaderSubjects[0]}n
            <li style={{ marginLeft: "1em" }}>geben Sie an, wo und wann Sie bereits {istTarifvertrag ? `` : `als ${ panelHeaderSubjects[1] }`} gearbeitet haben</li>
            {!lehrauftragPanel && <li style={{ marginLeft: "1em" }}>geben Sie an, ob Sie zusätzlich zu Ihrer Tätigkeit an der Bergischen Universität Wuppertal ein weiteres Beschäftigungsverhältnis haben</li>}
            <li style={{ marginLeft: "1em" }}>geben Sie an, wann Sie in den letzten 12 Monaten vor Vertragsbeginn befristet beschäftigt waren</li>
            <li style={{ marginLeft: "1em" }}>Bitte <b>alle</b> {panelHeaderSubjects[2]} auflisten.</li>
          </ul>
          <br />
        </span>}
        {hilfskraftPanel && <Hilfskraft
          subpanels={[hilfskraftPanel]}
          schema={schemaHilfskraft}
          readonly={antrag}
          currentAntrag={antrag}
          disabled={false}
          additionalInjects={entityContainer}
          panelName={hilfskraftPanel.header}
          action={actionHilfskraft}
          typField='mne_metid'
          typUniqueField='pwb_id'
          parentEntity={entityContainer}
          onSave={this.saveBeschäftigung}
          onDelete={this.deleteBeschäftigung}
          afterCommit={this.updateGUI}
        />}
        {lehrauftragPanel && <Lehrauftrag
          subpanels={[lehrauftragPanel]}
          schema={schemaLehrauftrag}
          readonly={antrag}
          currentAntrag={antrag}
          disabled={false}
          additionalInjects={entityContainer}
          panelName={lehrauftragPanel.header}
          action={actionLehrauftrag}
          typField='mne_metid'
          typUniqueField='pwb_id'
          parentEntity={entityContainer}
          onSave={this.saveBeschäftigung}
          onDelete={this.deleteBeschäftigung}
          afterCommit={this.updateGUI}
        />}
        {ausserhalbPanel && <Ausserhalb
          subpanels={[ausserhalbPanel]}
          schema={schemaAusserhalb}
          readonly={antrag}
          currentAntrag={antrag}
          // disabled={!statusPanels}
          additionalInjects={entityContainer}
          panelName={ausserhalbPanel.header}
          action={actionAusserhalb}
          typField='mne_metid'
          typUniqueField='pwb_id'
          parentEntity={entityContainer}
          onSave={this.saveBeschäftigung}
          onDelete={this.deleteBeschäftigung}
          afterCommit={this.updateGUI}
        />}
        {befristetPanel && <BefristetJahresbeginn
          subpanels={[befristetPanel]}
          schema={schemaBefristet12Monate}
          readonly={antrag}
          currentAntrag={antrag}
          additionalInjects={entityContainer}
          panelName={befristetPanel.header}
          action={actionBefristetJahresbeginn}
          typField='mne_metid'
          typUniqueField='pwb_id'
          parentEntity={entityContainer}
          onSave={this.saveBeschäftigung}
          onDelete={this.deleteBeschäftigung}
          afterCommit={this.updateGUI}
        />}

      </Panel>}

    </div>;
  };

  onBVInfo = entities => {
    // SHK-Form meldet Fetch/Änderung von Daten
    const entity = entities.edits.weiterebv ? entities.edits.weiterebv : entities.weiterebv;
    this.setState({ needDetail: entity && entity.p_weiterebv_jn });
  };

  updateGUI = () => {
    // Aktuellen Stand anzeigen lassen
    this.refetch();
  };

  saveBeschäftigung = async(entity, data, arrayinfo) => {
    // type information hinzufügen
    data.pwb_type = arrayinfo.wbtype;

    const url = `/api/shkperson/weiterebv`;
    await apifetch(url, {
      method: "POST",
      body: data,
    });
    this.refetch();
  };

  deleteBeschäftigung = async(entity, id) => {
    if (_.isEmpty(id)) {
      // Nichts zu tun
    } else {
      const url = `/api/shkperson/weiterebv/${ id }`;
      await apifetch(url, {
        method: "DELETE",
      });
      this.refetch();
    }
  };
}
